var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTriangleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 19.3333V0.666656L15.3332 9.99999L0.666504 19.3333Z",
    fill: "#FEF7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangleWhite);
export default __webpack_public_path__ + "static/media/right-triangle-white.24cb85333c1c80c2bc53b44e289112da.svg";
export { ForwardRef as ReactComponent };